module.exports = __webpack_public_path__ + "img/arrow-down-xs.1a33b777.svg";